import * as Yup from "yup";

import { ActualEscrow } from "@eave/shared/types/api";

const numberZeroOrGreaterRequired = Yup.number().min(0).required("Required");

export const validationSchema = Yup.object().shape({
  actual_tax_payment: numberZeroOrGreaterRequired,
  actual_insurance_payment: numberZeroOrGreaterRequired,
  actual_mortgage_insurance_payment: numberZeroOrGreaterRequired,
  actual_disbursement_amount: numberZeroOrGreaterRequired,
});

export const getInitialValues = (p: ActualEscrow | undefined, period: string | undefined) => ({
  payment_period: p ? p.payment_period : period,
  actual_tax_payment: p ? p.actual_tax_payment : "",
  actual_insurance_payment: p ? p.actual_insurance_payment : "",
  actual_mortgage_insurance_payment: p ? p.actual_mortgage_insurance_payment : "",
  actual_disbursement_amount: p ? p.actual_disbursement_amount : "",
});
